import _ from 'lodash';
import React, { PropTypes } from 'react';
import classNames from 'classnames';
import { DragHandle } from './NavbarList';

import { icon } from './../../icons/icons';

const NavbarThumb = (props) => {
    const { page, pagesList, index, actions } = props;
    const navbarClass = classNames({
        'page': true,
        'page--editing': page.editing,
        'page--active': page.active,
        'page--empty': _.isEmpty(page.widgets),
    });

    const setActivePage = () => {
        actions.setActivePage(page.id);
        actions.setWidgetTools('general', null);
    };

    const deletePage = (e) => {
        e.stopPropagation();
        actions.setModal('DELETE', 'Warning', 'Are you sure you want to delete this page ?', page.id);
    };

    const onEdit = (e) => {
        e.stopPropagation();
        if (page.editing === true) {
            actions.setEditingPage(page.id, false);
        } else {
            actions.setEditingPage(page.id, true);
        }
    };
    return (
        <li className={navbarClass} onClick={setActivePage} title="Click and hold to move">
            {
                (page.id === _.last(pagesList)) ?
                    <span className="page__label">Thank you</span> :
                    <span className="page__label">{(index === 0) ? 'Welcome' : `Page ${index}`}</span>
            }

            <div className="page__icons">
                <div className="icon icon-label page__clone" title="Copy">{ icon.clone()}<span>Copy</span></div>
                <div className="icon icon-label page__delete" title="Delete" onClick={deletePage}>{ icon.thrash()}<span>Delete</span></div>
                <DragHandle />
            </div>

            <div className="page__icon">
                { icon.page() }
                <span className="page__number">{ (index === 0) ? icon.home() : index }</span>
            </div>
            {(page.type === 2) ? <div className="icon page__edit" title="Edit" onClick={onEdit}>{ icon.gear()}</div> : ''}
        </li>
    );
};

NavbarThumb.propTypes = {
    page: PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.number.isRequired,
        draggable: PropTypes.bool.isRequired,
    }).isRequired,
};

export default NavbarThumb;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Navbar/NavbarThumb.jsx